import React from "react";
import { BottomSheetContext, type BottomSheetContent } from "./bottom-sheet-context";

export function BottomSheetProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = React.useState(false);
  const [content, setContent] = React.useState<BottomSheetContent>("CTA");
  const [selectedCtaIndex, setSelectedCtaIndex] = React.useState<number>(0);

  const openBottomSheet = React.useCallback((newContent: BottomSheetContent, ctaIndex?: number) => {
    if (ctaIndex !== undefined) {
      setSelectedCtaIndex(ctaIndex);
    }
    setContent(newContent);
    setOpen(true);
  }, []);

  const value = React.useMemo(
    () => ({
      open,
      content,
      selectedCtaIndex,
      setOpen,
      setContent,
      setSelectedCtaIndex,
      openBottomSheet,
    }),
    [open, content, selectedCtaIndex, openBottomSheet]
  );

  return (
    <BottomSheetContext.Provider value={value}>
      {children}
    </BottomSheetContext.Provider>
  );
}
